/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".same-code-note[_ngcontent-%COMP%]{font-size:.8rem;line-height:1.4;margin-top:4px;opacity:.75}.same-code-lock[_ngcontent-%COMP%]{font-style:italic}"];
export { styles as styles };
